__turbopack_context__.v({
  "buyButtonsPanel": "buy-buttons-panel-module-scss-module__sWUQSq__buyButtonsPanel",
  "fullWidth": "buy-buttons-panel-module-scss-module__sWUQSq__fullWidth",
});
